import PropTypes from "prop-types"
import { Link, graphql, useStaticQuery } from "gatsby"
import { rightAlign, pager } from "./pager.module.scss"
import { base, main, arrowLeft, arrowRight } from "../button.module.css"
import { reduceMicrocopySet } from "@utils/reduceMicrocopy"

const defaultLabelSet = {
  "pager.newer": "Newer posts",
  "pager.older": "Older posts",
}

const Pager = ({ currentPage, numPages, baseUrl }) => {
  const data = useStaticQuery(
    graphql`
      {
        microcopySet: contentfulMicrocopySet(contentful_id: { eq: "16MIcu8796hf76xTwkCC5u" }) {
          id
          items {
            text
            title
          }
        }
      }
    `
  )

  const onFirstPage = currentPage === 1
  const onLastPage = currentPage === numPages
  const priorPage = `${baseUrl}${currentPage - 1 === 1 ? "" : currentPage - 1}`
  const nextPage = `${baseUrl}${currentPage + 1}`
  const labels = reduceMicrocopySet(data.microcopySet) || defaultLabelSet
  const firstPageProblems = onFirstPage ? rightAlign : null

  return (
    <div className={`${pager} ${firstPageProblems}`}>
      {!onFirstPage && (
        <Link to={priorPage} className={`${base} ${main} ${arrowLeft}`}>
          {labels["pager.newer"]}
        </Link>
      )}
      {!onLastPage && (
        <Link to={nextPage} className={`${base} ${main} ${arrowRight}`}>
          {labels["pager.older"]}
        </Link>
      )}
    </div>
  )
}

export default Pager

Pager.propTypes = {
  numPages: PropTypes.number,
  currentPage: PropTypes.number,
  baseUrl: PropTypes.string,
}
